import React from "react";
import { t } from "../data/portfolio";

/*
 * Ölçüm grafiği. Proje verisindeki `chart` alanı varsa proje sayfasında
 * çizilir. Görsele değil, gerçek sayıya dayanır:
 *
 * chart: {
 *   title: {tr, en},
 *   note: {tr, en},
 *   series: [{ key, label: {tr,en}, tone: "primary" | "muted" }],
 *   rows: [{ label: {tr,en}, highlight: true, values: { key: 96.0 } }],
 *   max: 100,
 *   unit: "%",
 * }
 */
export default function BarChart({ chart, lang }) {
  const max = chart.max || 100;
  const unit = chart.unit || "";

  return (
    <figure className="chart">
      <figcaption className="chart-head">
        <h3>{t(chart.title, lang)}</h3>
        <ul className="chart-legend">
          {chart.series.map((s) => (
            <li key={s.key} className={`legend-${s.tone || "primary"}`}>
              <i aria-hidden="true" />
              {t(s.label, lang)}
            </li>
          ))}
        </ul>
      </figcaption>

      <div className="chart-rows">
        {chart.rows.map((row) => (
          <div className={`chart-row ${row.highlight ? "is-highlight" : ""}`} key={t(row.label, lang)}>
            <span className="chart-label">{t(row.label, lang)}</span>

            <div className="chart-bars">
              {chart.series.map((s) => {
                const value = row.values[s.key];
                return (
                  <div className="chart-bar" key={s.key}>
                    <div
                      className={`chart-fill chart-fill--${s.tone || "primary"}`}
                      style={{ width: `${(value / max) * 100}%` }}
                    />
                    <span className="chart-value">
                      {value.toFixed(1).replace(".", ",")}
                      {unit}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>

      {chart.note && <p className="chart-note">{t(chart.note, lang)}</p>}
    </figure>
  );
}
